import React, { useState,useEffect,useRef } from "react";
import { Grid2, Typography, Button, Box } from "@mui/material";
import TradeBossLogo from "../../../ui-utils/latestPics/aboutus.svg";
import AboutUsWebviewStyles from "./AboutUsWebView.module.css";
import { ReadMore } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import en from "../../../i18n/English/Aboutus/aboutus.json";
import hi from "../../../i18n/Hindi/Aboutus/aboutus.json";
import kn from "../../../i18n/Kannada/Aboutus/aboutus.json";
import ma from "../../../i18n/Marathi/Aboutus/aboutus.json";
import gu from "../../../i18n/Gujarati/Aboutus/aboutus.json";
import { useLanguage } from "../../../Context/LangContext";
import DocumentMeta from 'react-document-meta'

const meta = {
  title: 'Leading NSE, BSE & CDSL Trading Platform in India | TradeBoss',
  description: 'Discover TradeBoss, India’s trusted NSE, BSE trading platform for stocks, bonds, mutual funds & IPOs. Empowering NRIs & HNIs for 25+ years.',
  canonical: 'https://tradeboss.co/aboutus',
  meta: {
    charset: 'utf-8',
    name: {
      keywords: 'Indian trading platform, NSE trading platform, BSE trading platform, stock trading company India, best online broker India, trusted NSE BSE broker, Leading NSE, BSE, CDSL trading platform, Invest in stocks, bonds, Invest in mutual funds, Invest in gold, Invest in IPOs. Trusted by NRIs, HNIs'
    }
  }
}

export default function AboutUs() {
  // const [expanded, setExpanded] = useState(false);

  const scrollContainerRef = useRef(null);
  const [isUserScrolling, setIsUserScrolling] = useState(false);
  const naviage=useNavigate()

     const { language } = useLanguage();
     const translations = { en, hi, kn ,ma,gu };
   const t = translations[language] || translations.en ;
  return (
    <Grid2 className={AboutUsWebviewStyles.outer_card}>
      <DocumentMeta {...meta} />
      {/* <Typography className={AboutUsWebviewStyles.heading} style={{ fontWeight: 600 }}>

        {t.heading}
      </Typography> */}
      <div className={AboutUsWebviewStyles.headingContainer}>
        <div className={AboutUsWebviewStyles.gradientBackground}></div>
        <Typography className={AboutUsWebviewStyles.heading} style={{ fontWeight: 600 }}>
          {t.heading}
        </Typography>
      </div>
      <Grid2 className={AboutUsWebviewStyles.middleCard}>
        <Typography className={AboutUsWebviewStyles.content}>
          {/* Trade Boss, powered by */}
          {t.subtxt}
          <span className={AboutUsWebviewStyles.subContent} style={{fontWeight:600}}>{t.title}{" "}</span>{t.subtxt1}
        </Typography>
        <Grid2 className={AboutUsWebviewStyles.pic}>
          <img src={TradeBossLogo} alt="Tradeboss Logo"  />
        </Grid2 >
      </Grid2>
      <Button className={AboutUsWebviewStyles.button} onClick={()=>naviage('/support/contact')}>
      {/* Reach Out To Us */}
      {t.button}
      </Button>

    </Grid2>
  );
}
